<template>
    <div>
        <CartOrderItem
            v-for="(cartItem) in cartItemList"
            :key="cartItem.rowKey"
            :cartItem="cartItem"
            @updateItem="updateItem()"
            @deleteItem="deleteItem(cartItem)"
            @editOrder="editOrder(cartItem)"
        ></CartOrderItem>
    </div>
</template>

<script>
import CartOrderItem from "./CartOrderItem.vue";
//service
import BKCart from '../service/BKCart.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
export default {
    name: "CartOrderList",
    mixins: [LocaleMixin,ModalMixin],
    inject: ['CartCountStore'],
    components: {
        CartOrderItem
    },
    data: function() {
        return {
            isLoaded: false,
            cartItemList: [],
        }
    },
    created: function() {
        if (this.apiGetCartItem()) {
            this.isLoaded = true;
        }
    },
    methods: {
        updateItem: function () {
            this.$emit('updateItem');
        },
        editOrder: function(cartItem) {
            let campaignId = null;
            if (cartItem.parentCampaignId) {
                campaignId = cartItem.parentCampaignId;
            } else {
                campaignId = cartItem.campaignId;
            }
            this.$router.push("/product/" + campaignId + '?key=' + cartItem.rowKey);
        },
        deleteItem: async function (cartItem) {
            this.modal.loadingModal.show();
            if (await this.apiDeleteCartItem(cartItem.rowKey)) {
                this.isLoaded = false;
                if (await this.apiGetCartItem()) {
                    this.isLoaded = true;
                    this.modal.loadingModal.hide();
                    this.CartCountStore.methods.updateCartCountFromCartItem(this.cartItemList);
                }
            }
        },
        apiGetCartItem: async function() {
            return new Promise((resolve) => {
                BKCart.apiGetCartItem().subscribe({
                    next: (data) => {
                        this.cartItemList = data;
                        this.$emit('onLoaded');

                        if (this.cartItemList == 0) {
                            this.$emit('orderempty');
                        }
                        resolve(true);
                    },
                    error: (err) => {
                        this.$emit('onLoaded');
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        apiDeleteCartItem: async function(rowKey) {
            return new Promise((resolve) => {
                BKCart.apiDeleteCartItem(rowKey).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(true);
                    },
                    error: (err) => {
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        getData: function() {
            return this.cartItemList;
        },
    }
}
</script>

<style>

</style>
